import React from 'react'
import Page from 'ui/page'
import { Row, Col, Button } from 'reactstrap'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import barcelonaCardImage from 'goforajourney/img/barcelona-card'
import mexicoCityCardImage from 'goforajourney/img/mexico-city-card'
import mexicoAllCardImage from 'goforajourney/img/mexico-all-card'
import madridCardImage from 'goforajourney/img/madrid-card'
import marrakechCardImage from 'goforajourney/img/marrakech-card'

import barcelonaTour from 'goforajourney/img/barcelona-tour'
import madridTour from 'goforajourney/img/madrid-tour'
import mexicoCityTour from 'goforajourney/img/mexico-city-tour'

import { isMobile } from 'react-device-detect'
import drawing from 'goforajourney/img/drawing'

const HomeCard = styled.figure.attrs({
  className: ''
})`
  position: relative;
  cursor: pointer;

  img {
    width: 100%;
    border-radius: 35px;
  }

  figcaption {
    color: white;
    border-radius: 35px;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    text-shadow: 0 0 5px #000000;
    transition: all 0.3s ease-out;

    &:hover {
      background: rgba(0, 0, 0, 0.2);
    }

    a {
      font-size: 2.35em;
      color: white;
      font-weight: 800;
    }
  }
`

const ExperienceCard = styled(Col)`
  display: flex;
  flex-direction: column;

  p {
    flex-grow: 1;
  }
`

const Headline = () => (
  <Row>
    <Col xs="12" sm="12" className="text-center">
      <div className="my-3 mt-sm-5 mb-sm-0 p-3">
        <h1 className="fw-bold" style={{ fontSize: '3em' }}>
          Small groups · Big flavor · Real stories
        </h1>
        <div className="mt-2 mt-sm-5" style={{ fontSize: '1.2em' }}>
          We design curated food and culture tours to connect you with local life, through taste, tradition, and the people who know it best.
        </div>
      </div>
    </Col>
  </Row>
)

const DestinationCards = ({ urls }) => {
  if (isMobile) {
    return (
      <div>
        <Row>
          <Col xs="12" sm="6">
            <HomeCard onClick={() => (window.location.href = urls.destinations.barcelona)}>
              <img src={barcelonaCardImage} alt="Barcelona" />
              <figcaption className="shadow-lg">
                <a href={urls.destinations.barcelona}>Barcelona</a>
              </figcaption>
            </HomeCard>
          </Col>
          <Col xs="12" sm="6" className="mt-2">
            <HomeCard onClick={() => (window.location.href = urls.destinations.madrid)}>
              <img src={madridCardImage} alt="Madrid" />
              <figcaption className="shadow-lg">
                <a href={urls.destinations.madrid}>Madrid</a>
              </figcaption>
            </HomeCard>
          </Col>
          <Col xs="12" sm="6" className="mt-2">
            <HomeCard onClick={() => (window.location.href = urls.destinations.mexico_city)}>
              <img src={mexicoCityCardImage} alt="Mexico City" />
              <figcaption className="shadow-lg">
                <a href={urls.destinations.mexico_city}>Mexico City</a>
              </figcaption>
            </HomeCard>
          </Col>
        </Row>
      </div>
    )
  } else {
    return (
      <Row className="mt-5 mx-5 pb-5">
        {[
          { city: 'barcelona', img: barcelonaCardImage },
          { city: 'madrid', img: madridCardImage },
          { city: 'mexico_city', img: mexicoCityCardImage },
          { city: 'marrakech', img: marrakechCardImage }
        ].map(({ city, img }) => (
          <Col key={city} xs="3">
            <HomeCard onClick={() => (window.location.href = urls.destinations[city])}>
              <img src={img} alt={city} />
              <figcaption className="shadow-lg">
                <a href={urls.destinations[city]}>{city.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}</a>
              </figcaption>
            </HomeCard>
          </Col>
        ))}
      </Row>
    )
  }
}

const BestExperiences = ({ urls }) => {
  const { products } = urls

  return (
    <div style={{ background: '#f9f9f9' }} className="w-100 mt-3 px-md-5">
      <div className="container-fluid">
        <div className="mt-5 px-3 py-5 p-md-5">
          <Row>
            <Col className="flex-column">
              <h2 className="fw-bold text-center mb-5" style={{ fontSize: '2.5em' }}>
                Most Popular Experiences
              </h2>
              <p className="text-center">
                What is worth to see and taste in Barcelona, Madrid or Mexico City?
                <br />
                Check a selection of our most booked small-group and private tours.
              </p>
              <Row>
                {/* Barcelona */}
                <ExperienceCard
                  xs="12"
                  sm="6"
                  lg="4"
                  className="mt-5"
                  style={{ cursor: 'pointer' }}
                  onClick={() => (window.location.href = products.barcelona)}
                >
                  <img className="w-100" src={barcelonaTour} style={{ borderRadius: '35px 35px 0 0 ' }} alt="Barcelona tour" />
                  <h3 className="mt-4">
                    <a className="text-dark fw-bold" href={products.barcelona}>
                      Barcelona: Full Gaudi Tour with Sagrada Familia
                    </a>
                  </h3>
                  <div className="d-flex mb-2 mt-3">
                    <div className="me-3">
                      <i className="fa fa-clock text-primary me-1" />6.5 hours
                    </div>
                    <div>
                      <i className="fa fa-users text-primary me-1" />Small group
                    </div>
                  </div>
                  <p className="mt-3">
                    See Gaudí’s masterpieces in one day, explore the facade of Casa Batllo, enter Casa Mila, Park
                    Guell and the Sagrada Familia, and enjoy tapas and cava tasting.
                  </p>
                  <div className="text-center d-flex justify-content-between">
                    <div className="h4 d-flex align-self-center" style={{ fontWeight: 500 }}>
                      <small>
                        From <strong style={{ fontSize: '1.3em' }}>199€</strong> per person
                      </small>
                    </div>
                    <Button color="primary text-center p-3" className="rounded-3 fw-medium" style={{ fontSize: '1.2em' }}>
                      <i className="far fa-calendar-alt me-2" />
                      Check availability
                    </Button>
                  </div>
                </ExperienceCard>

                {/* Madrid */}
                <ExperienceCard
                  xs="12"
                  sm="6"
                  lg="4"
                  className="flex-column mt-5"
                  style={{ cursor: 'pointer' }}
                  onClick={() => (window.location.href = products.madrid)}
                >
                  <img className="w-100" src={madridTour} style={{ borderRadius: '35px 35px 0 0 ' }} alt="Madrid tour" />
                  <h3 className="mt-4">
                    <a className="text-dark fw-bold" href={products.madrid}>
                      Madrid: Royal Palace with Wine Tasting Tour
                    </a>
                  </h3>
                  <div className="d-flex mb-2 mt-3">
                    <div className="me-3">
                      <i className="fa fa-clock text-primary me-1" />2.5 hours
                    </div>
                    <div>
                      <i className="fa fa-users text-primary me-1" />Small group
                    </div>
                  </div>
                  <p className="mt-3">
                    Visit the Royal Palace and its grandest rooms, stroll the gardens, and end with a glass of Spanish wine on a terrace with palace views.
                  </p>
                  <div className="text-center d-flex justify-content-between">
                    <div className="h4 d-flex align-self-center" style={{ fontWeight: 500 }}>
                      <small>
                        From <strong style={{ fontSize: '1.3em' }}>59€</strong> per person
                      </small>
                    </div>
                    <Button color="primary text-center p-3" className="rounded-3 fw-medium" style={{ fontSize: '1.2em' }}>
                      <i className="far fa-calendar-alt me-2" />
                      Check availability
                    </Button>
                  </div>
                </ExperienceCard>

                {/* Mexico City */}
                <ExperienceCard
                  xs="12"
                  sm="6"
                  lg="4"
                  className="flex-column mt-5"
                  style={{ cursor: 'pointer' }}
                  onClick={() => (window.location.href = products.mexico_city)}
                >
                  <img className="w-100" src={mexicoCityTour} style={{ borderRadius: '35px 35px 0 0 ' }} alt="Mexico City tour" />
                  <h3 className="mt-4">
                    <a className="text-dark fw-bold" href={products.mexico_city}>
                      Mexico City: Coyoacan Tacos & Street Food Tour
                    </a>
                  </h3>
                  <div className="d-flex mb-2 mt-3">
                    <div className="me-3">
                      <i className="fa fa-clock text-primary me-1" />3 hours
                    </div>
                    <div>
                      <i className="fa fa-users text-primary me-1" />Small group
                    </div>
                  </div>
                  <p className="mt-3">
                    Explore Coyoacan with local market visits, taste street tacos and handmade ice cream, and end
                    at the iconic Frida Kahlo Museum.
                  </p>
                  <div className="text-center d-flex justify-content-between">
                    <div className="h4 d-flex align-self-center" style={{ fontWeight: 500 }}>
                      <small>
                        From <strong style={{ fontSize: '1.3em' }}>69€</strong> per person
                      </small>
                    </div>
                    <Button color="primary text-center p-3" className="rounded-3 fw-medium" style={{ fontSize: '1.2em' }}>
                      <i className="far fa-calendar-alt me-2" />
                      Check availability
                    </Button>
                  </div>
                </ExperienceCard>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

const DrawingExperience = (props) => {
  const externalLinkDrawing = 'https://gfabfac.palisis.com/'

  return (
    <div className="px-md-5" style={{ background: `url(${drawing})`, backgroundBlendMode: 'multiply', backgroundColor: 'rgba(0, 0, 0, 0.4)' }}>
      <div className="p-5">
        <Row>
          <Col>
            <h3 className="text-primary mb-5" style={{ fontSize: '1em' }}>SKETCHING</h3>
            <h4 className="text-white" style={{ fontSize: '3em', fontWeight: 500 }}>
              Sketching Experience<br />
              Multiday Trips in Barcelona and Mexico City
            </h4>
            <div className="text-white mt-5 fw-medium">
              <p>Discover our multiday drawing tours with artist Damon Lehrer, launching in Barcelona and Mexico City.</p>
              <p>Visit art landmarks and inspiring locations while sketching and painting along the way. We design this experience for those who want to see the world with an artist’s eye.</p>
              <p className="m-0">Follow in the footsteps of Picasso, Gaudi, or Frida Kahlo as you explore the places that shaped their creative vision.</p>
              <Button size="lg" color="primary mt-5 p-3 fw-medium" href={externalLinkDrawing} target="_blank" rel="noreferrer noopener">
                Find out More
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

const JoinCommunity = () => (
  <div className="p-5 text-center">
    <Row>
      <Col className="py-3">
        <h2 className="fw-bold mb-5">Join GoforaJourney Travel Community</h2>
        <p>
          Join a growing community of travelers, creators, and curious minds who explore the world
          through food, culture, and shared experiences.
        </p>
        <p className="m-0">
          Follow us on Instagram{' '}
          <a
            href="https://www.instagram.com/goforajourney_tours"
            className="text-primary"
            rel="noopener noreferrer"
            target="_blank"
          >
            @goforajourney_tours
          </a>{' '}
          for local tips, behind-the-scenes moments, and a taste of what we’re building together.
        </p>
      </Col>
    </Row>
  </div>
)

const Index = (props) => (
  <Page {...props} className="p-0">
    <div className={isMobile ? 'container' : 'container-fluid'}>
      <Headline {...props} />
    </div>
    <div className={isMobile ? 'container px-3' : 'container-fluid px-md-5'}>
      <DestinationCards {...props} />
    </div>
    <BestExperiences {...props} />
    <JoinCommunity {...props} />
    <DrawingExperience {...props} />
  </Page>
)

export default Index
